import {BaseConverter} from "../../base/converters/base-converter.converter";
import {ModifyDraftModel} from "../models/modify-draft.model";
import {ModifyDraft} from "../../shared/DTO/modifyDraft";
import {Injectable} from "@angular/core";
import * as moment from "moment";

@Injectable()
export class ModifyDraftConverter extends BaseConverter<ModifyDraftModel, ModifyDraft> {
  convertToDto(model: ModifyDraftModel): ModifyDraft {
    if (!model) {
      return;
    }
    return {
      changeOperator: model.changeOperator,
      expirationDate: model.expirationDate?.toISOString() || undefined,
      name: model.name,
      reserved: model.reserved,
      state: model.state
    };
  }

  convertToModel(dto: ModifyDraft): ModifyDraftModel {
    if (!dto) {
      return;
    }
    let model: ModifyDraftModel = new ModifyDraftModel();
    model.state = dto.state;
    model.reserved = dto.reserved;
    model.name = dto.name;
    model.expirationDate = dto.expirationDate ? moment(dto.expirationDate) : null;
    model.changeOperator = dto.changeOperator;
    return model;
  }

}
